import type {
  AppointmentFilter,
  AppointmentPageParams,
} from "@/features/clinic/types/appointment";

export const appointmentKeys = {
  all: ["appointments"] as const,
  lists: () => [...appointmentKeys.all, "list"] as const,
  list: (workspaceId: string, filters: AppointmentFilter = {}) =>
    [...appointmentKeys.lists(), workspaceId, { filters }] as const,
  /** Under `lists()` like `blockedCounts`, so every write that invalidates the
   *  rows refetches the page too; the list writers skip it as not an array. */
  page: (
    workspaceId: string,
    filters: AppointmentFilter,
    { page, limit }: AppointmentPageParams,
  ) =>
    [
      ...appointmentKeys.lists(),
      "page",
      workspaceId,
      { filters, page, limit },
    ] as const,
  details: () => [...appointmentKeys.all, "detail"] as const,
  detail: (id: string) => [...appointmentKeys.details(), id] as const,
  /** Under `lists()` so every mutation that invalidates the rows moves the
   *  counts too - as a sibling they went stale for the whole session. */
  blockedCounts: (workspaceId: string) =>
    [...appointmentKeys.lists(), "blocked-counts", workspaceId] as const,
  crmSchedule: (
    integrationId: string,
    doctorId: string,
    from: string,
    to: string,
  ) =>
    [
      ...appointmentKeys.all,
      "crm-doctor-schedule",
      integrationId,
      doctorId,
      from,
      to,
    ] as const,
};
